<template>

  <v-container>

    <v-overlay :value="loading">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-snackbar v-model="snackbars.errorSnackbar" color="error">

      Please fix the error(s) on the form.

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.errorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="snackbars.genericInfoSnackbar" color="primary">

      {{ snackbars.genericInfoText }}

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.genericInfoSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="snackbars.genericErrorSnackbar" color="error">

      {{ snackbars.genericErrorText }}

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.genericErrorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-layout class="mb-2">

      <v-spacer></v-spacer>

      You are signed in as&nbsp;<strong>{{ $store.state.user.email }}</strong>&nbsp;<span v-if="$store.state.user.role != 'User'">({{ $store.state.user.role == 'Admin' ? 'Administrator' : $store.state.user.role }})</span>

    </v-layout>

    <v-card elevation="0" class="pa-2">

      <v-card-title class="text-h5 word-break"><strong>Send Test Email</strong></v-card-title>

      <v-card-text class="text-body-1">

        <p>To send a test email, please provide an email address:</p>

        <v-layout class="ml-6 mr-4 mb-10 mt-6">

          <v-row>

            <div style="display: flex; flex-wrap: wrap; margin-bottom: 15px;">

              <div style="width: 50%; padding: 20px; min-width: 350px">

                <v-text-field label="Email" v-model="email" outlined></v-text-field>

              </div>

            </div>

          </v-row>

        </v-layout>

        <div style="text-align: right">

          <hr />

          <v-btn class="primary mt-4" @click="send"><v-icon left>mdi-email</v-icon>Send</v-btn>

        </div>

      </v-card-text>

    </v-card>

  </v-container>

</template>

<script lang="ts">

import Vue from 'vue'

import axios from "axios";

export default Vue.extend({

  name: 'SendTestEmail',

  methods: {

    send() {

      this.loading = true;

      setTimeout(async () => {

        var data = { email: this.email };

        let obj = await axios.post('api/Email/SendTestEmail', data);

        this.loading = false;

        if (obj.data == '%%SUCCESS%%') {

          this.snackbars.genericInfoText = 'The email has been sent.';

          this.snackbars.genericInfoSnackbar = true;

        }
        else
        {
          this.snackbars.genericErrorText = 'There was an issue sending the email.  Please contact the system administrator.';

          this.snackbars.genericErrorSnackbar = true;
        }

      }, 200);

    }

  },

  async created() {

    this.loading = true;

    setTimeout(async () => {

      try {

        let obj = await axios.get('accounts/get-user-info');

        var tokens = obj.data.split('\t');

        var email = tokens[1];

        var role = tokens[2];

        this.$store.dispatch('updateEmail', email);

        this.$store.dispatch('updateRole', role);

        let exceptions = await axios.get('api/Exception/GetLast10Exceptions');

        this.loading = false;

        this.exceptions = exceptions.data;

      }
      catch
      {
        if (this.$route.path != '/Login') this.$router.push('/Login');
      }

      this.loading = false;

    }, 200)

  },

  data () {

    return {

      loading: false,

      exceptions: '',

      email: '',

      snackbars: {

        errorSnackbar: false,

        genericErrorSnackbar: false,

        genericErrorText: '',

        genericInfoSnackbar: false,

        genericInfoText: '',

      }

    }

  }

})

</script>

<style>

.word-break {

  word-break: break-word;

}

th > .v-icon {

  color: white !important;

}

th, td {

  font-size: 18px !important;

}

</style>
